import pimg1 from '../images/project/img-1.jpg';
import pimg2 from '../images/project/img-2.jpg';
import pimg3 from '../images/project/img-3.jpg';
import pimg4 from '../images/project/img-4.jpg';
import pimg5 from '../images/project/img-5.jpg';
import pimg6 from '../images/project/img-6.jpg';
import pimg7 from '../images/project/img-7.jpg';
import pimg8 from '../images/project/img-8.jpg';
import pimg9 from '../images/project/img-9.jpg';
import pimg10 from '../images/project/img-10.jpg';
import pimg11 from '../images/project/img-11.jpg';
import pimg12 from '../images/project/img-12.jpg';


import p2img1 from '../images/project-single/1.jpg'
import p2img2 from '../images/project-single/2.jpg'
import p2img3 from '../images/project-single/3.jpg'
import p2img4 from '../images/project-single/4.jpg'
import p2img5 from '../images/project-single/5.jpg'
import p2img6 from '../images/project-single/6.jpg'
import p2img7 from '../images/project-single/7.jpg'
import p2img8 from '../images/project-single/8.jpg'
import p2img9 from '../images/project-single/9.jpg'
import p2img10 from '../images/project-single/10.jpg'
import p2img11 from '../images/project-single/11.jpg'
import p2img12 from '../images/project-single/12.jpg'




const Projects = [
    {
        id: '01',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions',
        pimg: pimg1,
        pSimg: p2img1,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '02',
        subtitle: 'Transport',
        title: 'Supply Chain Logistics Transport.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions2',
        pimg: pimg2,
        pSimg: p2img2,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
  
    {
        id: '03',
        subtitle: 'Transport',
        title: 'Air Freight Transport Solution.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions3',
        pimg: pimg3,
        pSimg: p2img3,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
  
    {
        id: '04',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions4',
        pimg: pimg2,
        pSimg: p2img4,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '05',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions5',
        pimg: pimg4,
        pSimg: p2img5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '06',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions6',
        pimg: pimg5,
        pSimg: p2img6,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '07',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions7',
        pimg: pimg6,
        pSimg: p2img7,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '08',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions8',
        pimg: pimg5,
        pSimg: p2img8,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '09',
        subtitle: 'Transport',
        title: 'Special Transport Solutions.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions9',
        pimg: pimg7,
        pSimg: p2img9,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '10',
        subtitle: 'Transport',
        title: 'Innovations in Modern Transportation',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions10',
        pimg: pimg8,
        pSimg: p2img10,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '11',
        subtitle: 'Transport',
        title: 'Urban Transportation',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions11',
        pimg: pimg9,
        pSimg: p2img11,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '12',
        subtitle: 'Transport',
        title: 'Sustainable Transportation',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions12',
        pimg: pimg10,
        pSimg: p2img12,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '13',
        subtitle: 'Transport',
        title: 'Maritime Transport.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions13',
        pimg: pimg11,
        pSimg: p2img5,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
    {
        id: '14',
        subtitle: 'Transport',
        title: 'Aviation Transport.',
        docomunt: 'Quis id at rhoncus consequat. Aliquam in. Velit phasellus augue tristique integer arcu. Elit sed vestibulum tristique suspendisse ut sit',
        slug: 'Special-Transport-Solutions14',
        pimg: pimg12,
        pSimg: p2img8,
        location: '7 Lake Street,London',
        date: '15 Dec 2024',
    },
  
   



]
export default Projects;






